const STORAGE_KEY = 'REPRO_I18N_SKIP_LOAD_IDIOMA'

/** Solo en desarrollo: simula el fallo del cliente (newSession sin textos + loadIdioma bloqueado). */
export function isI18nReproActive(): boolean {
  return import.meta.env.DEV && localStorage.getItem(STORAGE_KEY) === '1'
}

export function simulateBrokenTextosAfterNewSession<TIdioma, TTextos extends Record<string, string>>(
  idioma: TIdioma,
  textos: TTextos | undefined,
): { idioma: TIdioma; textos: Record<string, never> } | { idioma: TIdioma; textos: TTextos } {
  if (!isI18nReproActive()) {
    return { idioma, textos: textos as TTextos }
  }

  return { idioma, textos: {} }
}

export function shouldBlockLoadIdioma(): boolean {
  return isI18nReproActive()
}

export function registerI18nReproDevTools(): void {
  if (!import.meta.env.DEV) return

  const w = window as Window & {
    __reproI18n?: {
      enable: () => void
      disable: () => void
      status: () => boolean
    }
  }

  w.__reproI18n = {
    enable() {
      localStorage.setItem(STORAGE_KEY, '1')
    },
    disable() {
      localStorage.removeItem(STORAGE_KEY)
    },
    status() {
      return isI18nReproActive()
    },
  }
}
